import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';  ///----------- for searching pop up -----------
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-dialog-zoom',
  templateUrl: './dialog-zoom.component.html',
  styleUrls: ['./dialog-zoom.component.css']
})
export class DialogZoomComponent implements OnInit {
  wk_Data = '';
  @Output() submitClicked = new EventEmitter<any>();

  constructor(public dialogRef: MatDialogRef<DialogZoomComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public storage: LocalStorageService,)
              { this.wk_Data = data.wk_Data}

  ngOnInit(): void {
  }

}
